import React from "react";
import { Phone } from "lucide-react";
import LeadForm from "./LeadForm";
import { CONTACT_PHONE, CONTACT_PHONE_HREF, IMAGES } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function LeadSection() {
  const r = useReveal();
  return (
    <section id="cta" className="bg-ls py-20 md:py-28 border-t" style={{ borderColor: "var(--ls-border)" }}>
      <div ref={r.ref} className={`max-w-6xl mx-auto px-5 md:px-8 ${r.className}`}>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="ls-eyebrow mb-4">Get more jobs</p>
            <h2 className="font-display text-white text-[10vw] sm:text-5xl md:text-6xl mb-5">
              Tell me where the <span className="text-orange">leaks</span> are.
            </h2>
            <p className="text-lg text-[#b7ab9b] max-w-lg mb-6">
              Drop your info below. I'll build your website for free and wire up the system that answers the phone,
              texts them back, and books the job. $597/mo. Cancel anytime.
            </p>
            <a
              href={CONTACT_PHONE_HREF}
              className="inline-flex items-center gap-3 text-white font-cond font-bold text-2xl hover:text-orange transition-colors"
            >
              <span
                className="flex items-center justify-center w-10 h-10 rounded-[6px]"
                style={{ backgroundColor: "rgba(242,106,33,0.12)" }}
              >
                <Phone className="w-5 h-5 text-orange" />
              </span>
              {CONTACT_PHONE}
            </a>
            <p className="text-sm text-[#9a8f80] mt-2 font-cond tracking-wide">
              Prefer to talk? Call or text — I answer.
            </p>

            <div className="mt-8 rounded-lg overflow-hidden bg-black max-w-sm hidden lg:block hero-frame">
              <img src={IMAGES.deliver} alt="A booked job, straight to your calendar" className="w-full aspect-video object-cover" />
            </div>
          </div>

          <LeadForm source="home_cta" />
        </div>
      </div>
    </section>
  );
}
